import { styled } from 'styled-components';

export const Body = styled.p<{
    alignment?: 'center' | 'auto' | 'left' | 'right';
    $noWrap: boolean;
    $breakAnywhere?: boolean;
}>`
    text-align: ${({ alignment }) => alignment};
    color: ${({ color, theme }) => color || theme.textColor};
    ${({ $noWrap }) => $noWrap && 'white-space: nowrap;'}
    /* break-word breaks a word too long for its line, but the word still holds
       its container open at its full length; anywhere lets it shrink the
       container too. Not the default: squeezed, anywhere breaks ordinary words
       ("Offli-ne"), which break-word never does. */
    overflow-wrap: ${({ $breakAnywhere }) => ($breakAnywhere ? 'anywhere' : 'break-word')};
`;

export const Description = styled(Body)`
    font-size: ${({ theme }) => theme.descriptionSize};
    line-height: ${({ theme }) => theme.descriptionLineHeight};
    font-weight: 400;
`;

export const DescriptionMedium = styled(Description)`
    font-weight: 500;
`;

export const DescriptionBold = styled(Description)`
    font-weight: 600;
`;

export const DescriptionSmall = styled(Description)`
    font-size: ${({ theme }) => theme.descriptionSmall};
`;

export const DescriptionMediumSmall = styled(Description)`
    font-weight: 500;
    font-size: ${({ theme }) => theme.descriptionSmall};
`;
